import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-image-uploader',
    templateUrl: './image-uploader.component.html',
    styleUrls: ['./image-uploader.component.scss'],
})
export class ImageUploaderComponent implements OnInit {
    imagePathProfile: string = null;
    imagePathSignature: string = null;

    constructor() {}

    ngOnInit(): void {}

    changeHandler(event): void {
        // const file = (event.target as HTMLInputElement).files[0];
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onload = () => {
            if (event.target.id === 'imageFileProfile') {
                this.imagePathProfile = reader.result as string;
                console.log(this.imagePathProfile);
            }
            if (event.target.id === 'imageFileSignature') {
                this.imagePathSignature = reader.result as string;
            }
        };
        reader.readAsDataURL(file);
    }
}
